export type EmbedTheme = 'system' | 'light' | 'dark';

export function parseEmbedTheme(value: string | null): EmbedTheme | null {
  return value === 'system' || value === 'light' || value === 'dark' ? value : null;
}

export function withEmbedTheme(value: string, theme: EmbedTheme): string {
  const url = new URL(value);
  url.searchParams.set('theme', theme);
  return url.href;
}
